import React from 'react';
import PropTypes from 'prop-types';

function HitHeadline({headline}) {
    return (<h4 className="hit-faded-headline">{headline}</h4>);
}

HitHeadline.propTypes = {
    headline: PropTypes.string
};

export default HitHeadline;



// WEBPACK FOOTER //
// ./src/universal/components/Hit/HitSubComponents/HitFadedHeadline/HitFadedHeadline.js